import { html } from 'lit-element';
import { KatLitElement, register } from '../../shared/base';
import baseStyles from '../../shared/base/base.lit.scss';
import styles from './breadcrumb.lit.scss';

/**
 * @component {kat-breadcrumb} KatalBreadcrumb A breadcrumb is a series of horizontal links that allow users to understand their current place in the navigation hierarchy and navigate back to higher-level pages.
 * @slot default Should be filled with `kat-breadcrumb-item` elements.
 * @guideline Breadcrumbs should always appear at the top of a page.
 * @guideline Do Use "kat-breadcrumb-item" children.
 * @guideline Dont It is not recommended to use breadcrumbs in multiple places on a page or in the middle of a page.
 * @example SetViaHtml {"content": "<kat-breadcrumb-item label=\"Parent\" href=\"#\"></kat-breadcrumb-item><kat-breadcrumb-item label=\"Group\" href=\"#\"></kat-breadcrumb-item><kat-breadcrumb-item label=\"Category\" href=\"#\"></kat-breadcrumb-item><kat-breadcrumb-item label=\"Current Category\" href=\"#\"></kat-breadcrumb-item>"}
 * @status Production
 * @theme flo
 */
@register('kat-breadcrumb')
export class KatBreadcrumb extends KatLitElement {
  static get styles() {
    return [baseStyles, styles];
  }

  render() {
    return html`<slot></slot>`;
  }
}
